import { SHARE_EMAIL_CONSENT, TERMS_CONDITION_CONSENT } from "@/constants";
import { AuthState } from "../auth/state";
import { UPDATE_CONSENTS } from "./mutation-types";
import { RGPDState } from "./state";

export default {
    [UPDATE_CONSENTS](
        state: RGPDState,
        data: {
            authState: AuthState;
            consents: {
                termsAndConditionsConsent: boolean;
                shareEmailConsent?: boolean;
            };
        }
    ) {
        state.shareEmailConsent = data.consents.shareEmailConsent;
        state.termsAndConditionsConsent = data.consents.termsAndConditionsConsent;

        typeof data.consents.shareEmailConsent === "boolean"
            ? localStorage.setItem(SHARE_EMAIL_CONSENT, data.consents.shareEmailConsent.toString())
            : localStorage.removeItem(SHARE_EMAIL_CONSENT);

        typeof data.consents.termsAndConditionsConsent === "boolean"
            ? localStorage.setItem(
                  TERMS_CONDITION_CONSENT,
                  data.consents.termsAndConditionsConsent.toString()
              )
            : localStorage.removeItem(TERMS_CONDITION_CONSENT);
    }
};
